import React from "react";

const short = { DraftKings: "DK", FanDuel: "FD", BetMGM: "MGM", Caesars: "CZR", BetRivers: "BR", Fanatics: "FAN", theScore: "TS", "Hard Rock": "HR", Betr: "BETR", Circa: "CIRC" };

export const atgTitle = (a) =>
  `Anytime goal · best ${a.best} (${a.best_book}) · implied ${a.implied}%` +
  (a.model != null ? ` · model ${a.model}% · edge ${a.edge > 0 ? "+" : ""}${a.edge}` : "") +
  `\n${Object.entries(a.books || {}).map(([b, o]) => `${b} ${o}`).join(" · ")}`;

export const AtgChip = ({ atg, testId }) => {
  if (!atg) return null;
  return (
    <span
      data-testid={testId || "atg-chip"}
      title={atgTitle(atg)}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded px-1 font-mono text-[9px] font-semibold ${atg.value ? "bg-emerald-950/70 text-emerald-300 ring-1 ring-emerald-600/60" : "bg-slate-800/80 text-slate-300"}`}
    >
      ATG {atg.best}<span className="text-slate-500">{short[atg.best_book] || atg.best_book}</span>
      <span className="text-slate-400">{atg.implied}%</span>
      {atg.value && <span className="rounded bg-emerald-600 px-0.5 text-[8px] text-white">VALUE</span>}
    </span>
  );
};

export default AtgChip;
